import qs from 'qs'

const prefix = '/data-warehouse'

const paramsSerializer = (params) =>
  qs.stringify(params, { arrayFormat: 'comma' })

export { prefix, paramsSerializer }
